<template>
  <div class="sms-log-container">
    <tool-tip
      v-if="is_show_tool_tip"
      :text="text"
      @close-tool-tip="is_show_tool_tip = false"
    />
    <nav class="add-navigation">
      <div class="row pl-3">

        <div class=" search_margin col-md-4 col-12 ">
          <span class="filter_by">Filter by</span>
          <primary-select v-model="user_name" :options="users" />
        </div>


        <div class=" search_margin col-md-4 col-12 my-2 my-md-0">
          <date-time-picker
              header="From:"
              :initial_time="new Date(startTime)"
              @getTime="getStartTime"
          > </date-time-picker>
        </div>
        <div class=" input_margin col-md-4 col-12 my-2 my-md-0">
          <date-time-picker
              header="To:"
              :initial_time="new Date(endTime)"
              @getTime="getEndTime"
          ></date-time-picker>
        </div>

            <div class="  col-md-4 col-12">
              <search-input
                  class="search-input my-3 sm-w-100 "
                  type="text"
                  v-model="selectedDnis"
                  placeholder="DNIS"
              />
            </div>
            <div class="  col-md-4 col-12">
              <search-input
                  class="search-input my-3 sm-w-100"
                  type="text"
                  v-model="selectedAni"
                  placeholder="ANI"
              />
            </div>




        <div class="buttons-wrapper col-1 " style="min-width: 120px">
          <div @click="search" class="primary-button search_button    ">
            <primary-button>Submit</primary-button>
          </div>
        </div>
        <div class=" buttons-wrapper col-1 "  style="min-width: 120px">
          <div class=" search_button  margin_top_button   bl-3 ">
            <secondary-button  search_margin  @click="reasetFilters">Reset</secondary-button>
          </div>
        </div>


      </div>
    </nav>
    <loader :loading="loading" v-if="loading" />
    <not-found v-else-if="!smsLogsList.length || !showData" />
    <template v-else-if="!loading">
      <div
        class="table_div"
        style="width: 100%; overflow-x: auto; overflow-y: hidden"
      >
        <table class="Invoice_table">
          <thead>
            <tr class="Invoice_table_header">
              <th>
                Time
                <span v-on:click="sorting('up', 'sms_time')" class="sorting"
                  >&#8593;</span
                >
                <span v-on:click="sorting('down', 'sms_time')" class="sorting"
                  >&#8595;</span
                >
              </th>
              <th>
                DNIS
                <span v-on:click="sorting('up', 'dnis')" class="sorting"
                  >&#8593;</span
                >
                <span v-on:click="sorting('down', 'dnis')" class="sorting"
                  >&#8595;</span
                >
              </th>
              <th>
                ANI
                <span v-on:click="sorting('up', 'ani')" class="sorting"
                  >&#8593;</span
                >
                <span v-on:click="sorting('down', 'ani')" class="sorting"
                  >&#8595;</span
                >
              </th>
              <th>
                Company Name
                <!-- <span v-on:click="sorting('up','company_name')" class="sorting">&#8593;</span>
                <span v-on:click="sorting('down','company_name')" class="sorting">&#8595;</span>-->
              </th>
              <th>
                Username
                <span v-on:click="sorting('up', 'user_id')" class="sorting"
                  >&#8593;</span
                >
                <span v-on:click="sorting('down', 'user_id')" class="sorting"
                  >&#8595;</span
                >
              </th>
              <!-- <th>DLR</th> -->
              <th class="sms-text">Text</th>
              <!-- <th>Vendor result</th>
              <th>Client result</th>-->
            </tr>
          </thead>
          <tbody v-if="smsLogsList.length > 0">
            <tr class="line" v-for="(sms, k) in smsLogsList" :key="k">
              <th class="time-th">{{ sms.time }}</th>
              <th>{{ sms.dnis }}</th>
              <th>{{ sms.ani }}</th>
              <th>{{ sms.company_name }}</th>
              <th>{{ sms.user_name }}</th>
              <!-- <th>{{sms.dlr}}</th> -->
              <th
                class="sms-text word-break"
                @mouseover="
                  sms.text.length > showing_text_length
                    ? toggleToolTip(sms.text, true)
                    : null
                "
                @mouseleave="
                  sms.text.length > showing_text_length
                    ? toggleToolTip(sms.text, false, $event)
                    : null
                "
              >
                {{ sms.text | shortText(showing_text_length) }}
              </th>
              <!-- <th>{{ null }}</th>
              <th>{{ null }}</th>-->
            </tr>
          </tbody>
        </table>
      </div>
      <div class="per-page-box">
        <div class="header">
          <span class="filter_by per_page">Show Per Page</span>
        </div>
        <div class="item">
          <div
            class="primary-input-container choose-type perPage equal-field box"
            type="text"
            placeholder="Select"
          >
            <div class="primary-select-wrapper">
              <select v-model="per_page" :is-cross="false">
                <option
                  v-for="page in pages"
                  :key="page.name"
                  :value="page.value"
                >
                  {{ page.value }}
                </option>
              </select>
              <img src="/img/Down.08f08d5c.svg" alt class="icon-down" />
            </div>
          </div>
        </div>
      </div>
      <div class="buttons-wrapper">
        <pagination-component
          @change-page="changePage($event)"
          :page="Page"
          :total="totalPages"
          :perPage="per_page"
          :qnt="smsLogsList.length"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { format } from "date-fns";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    Loader: () => import("@/components/Loader.vue"),
    NotFound: () => import("@/components/NotFound.vue"),
    DateTimePicker: () => import("@/components/DateTime"),
    ToolTip: () => import("@/components/ToolTip"),
  },
  data: () => ({
    showing_text_length: 35,
    vendor: "",
    smsces: [],
    sms_id: "",
    selectedDnis: "",
    selectedAni: "",
    company_uuid: "",
    users: [],
    user_name: "",
    pages: [
      { name: 10, value: 10 },
      { name: 50, value: 50 },
      { name: 100, value: 100 },
    ],
    per_page: 10,
    Page: 0,
    Searched: "",
    ani: null,
    dnis: null,
    total: 0,
    loading: true,
    showData: Boolean,
    isShow: true,
    start_time: null,
    end_time: null,
    smsLogsList: [],
    totalPages: null,
    isClicked: false,
    text: "",
    is_show_tool_tip: false,
  }),
  computed: {
    ...mapGetters({
      smsList: "smses/getSmsList",
      smscTotalPages: "smsc/getTotalPages",
    }),
    smsLogs() {
      return this.smsList.map((sms) => ({
        text: sms.text,
        ani: sms.sent ? sms.sent.sender : null,
        user_name: sms.user_name,
        company_name: sms.company_name,
        time: this.dateFormat(sms.created_on),
        dnis: sms.sent ? sms.sent.receiver : null,
        dlr: sms.dlr_state,
        sentBy: sms.send_by,
      }));
    },
    startTime() {
      const { day, month, year } = this.getCurrentDateAndTime();

      return new Date(`${month}/${day}/${year} 00:00:00`).getTime();
    },
    endTime() {
      const { day, month, year } = this.getCurrentDateAndTime();

      return new Date(`${month}/${day}/${year} 23:59:59`).getTime();
    },
  },
  watch: {
    Searched: function () {
      this.Page = 0;
      // this.getList();
      this.GetSmsList();
    },
    company_uuid: function () {
      this.fetchUser();
    },
    filter: function () {
      if (this.filter_val) {
        this.Page = 0;
        // this.getList();
        this.GetSmsList();
      }
    },
    filter_val: function () {
      this.Page = 0;
      // this.getList();
      this.GetSmsList();
    },
    per_page(data) {
      this.Page = 0;
      // this.getList();
      this.GetSmsList();
    },
    loading(l) {
      this.$emit("loading", l);
    },
  },
  filters: {
    shortText(txt, length) {
      if (txt && txt.length > length) {
        return `${txt.substr(0, length).trim()}...`;
      }

      return txt;
    },
  },
  async created() {
    this.setDateAndTime();

    await this.fetchUser();
    this.getSmscList();
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  methods: {
    ...mapActions({
      viewSmsC: "smsc/getSmscList",
    }),
    toggleToolTip(text, is_show, e) {
      if (!is_show) {
        const t = e && e.toElement.classList.contains("tool-tip");
        if (t) {
          return;
        }
        this.is_show_tool_tip = is_show;
        this.text = "";
        return;
      }

      this.is_show_tool_tip = is_show;
      this.text = text;
    },
    getStartTime(t) {
      const time = new Date(t).getTime();
      this.start_time = time / 1000;
    },
    getEndTime(t) {
      const time = new Date(t).getTime();
      this.end_time = time / 1000;
    },
    oneToTwoDigit(num) {
      return num.length === 1 ? `0${num}` : num;
    },
    dateFormat(date) {
      const converted_date = new Date(date);
      const year = converted_date.getFullYear().toString().slice(2, 4);
      const _month = (converted_date.getMonth() + 1).toString();
      const month = this.oneToTwoDigit(_month);
      const day = converted_date.getDate();
      const _hours = converted_date.getHours().toString();
      const hours = this.oneToTwoDigit(_hours);
      const _minutes = converted_date.getMinutes().toString();
      const minutes = this.oneToTwoDigit(_minutes);
      const _seconds = converted_date.getSeconds().toString();
      const seconds = this.oneToTwoDigit(_seconds);

      return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    },
    getCurrentDateAndTime() {
      const date = new Date();
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return { day, month, year };
    },
    setDateAndTime() {
      this.start_time = this.startTime / 1000;
      this.end_time = this.endTime / 1000;
    },
    transformData(elem) {
      return {
        time: format(elem.sms_time * 1000, "YYYY:MM:DD HH:mm:ss"),
        dnis: elem.dnis,
        ani: elem.ani,
        company_name: elem.company_name,
        user_name: elem.user_name,
        dlr: elem.delivered,
        text: elem.sms_content,
      };
    },
    GetSmsList(order = "desc", sort = "sms_time") {
      this.loading = true;
      this.$store
        .dispatch("GetSmsLogListIncoming", {
          start_time: this.start_time,
          end_time: this.end_time,
          per_page: this.per_page,
          page: this.Page,
          dnis: this.selectedDnis ? `${this.selectedDnis}*` : "",
          ani: this.selectedAni ? `${this.selectedAni}*` : "",
          user_name: this.user_name || "",
          order,
          sort,
        })
        .then((res) => {
          this.loading = false;
          if (!res.data.length) {
            this.$swal({
              title: "No data found",
              text: "",
              type: "warning",
              showCancelButton: false,
              confirmButtonText: "Ok",
              cancelButtonText: "No",
            });
          }
          this.smsLogsList = res.data.map(this.transformData);
          this.totalPages = res.total / this.per_page;
        });
    },
    selectDateAndTime(e) {
      this.start_time = new Date(e[0]).getTime() / 1000;
      this.end_time = new Date(e[1]).getTime() / 1000;
      this.Page = 0;
    },
    getSMSCList() {
      this.$store.dispatch("GetVendorList", {}).then((res) => {
        const { total } = res;

        this.$store
          .dispatch("GetVendorList", { per_page: total })
          .then((res) => {
            this.vendors = res.items.map(this.transformVendor);
          });
      });
    },
    search() {
      this.GetSmsList();
    },
    fetchUser() {
      this.loading = true;
      this.$store.dispatch("GetUsers", { per_page: 1000 }).then((res) => {
        this.loading = false;
        if (this.company_uuid) {
          this.users = [];
        }
        const _res = [
          { name: "Select User", value: "" },
          ...res.items.map(this.transformUser).filter((item) => item.name),
        ];
        this.users = [...this.users, ..._res];
      });
    },

    sorting(type, sortBy) {
      let order = "";
      if (type === "up") {
        order = "desc";
      } else {
        order = "asc";
      }

      this.GetSmsList(order, sortBy);
    },
    reasetFilters() {
      this.Searched = "";
      this.filter = "ani";
      this.filter_val = "";
      this.vendor = "";
      this.sms_id = "";
      this.selectedDnis = "";
      this.selectedAni = "";
      (this.user = "All"), (this.showData = false);
    },
    changePage(page) {
      this.Page = page;
      this.GetSmsList();
    },
    async getSmscList(total, order_dir = "desc", order_by = "created_on") {
      this.loading = true;
      await this.viewSmsC({
        page: this.Page,
        perPage: this.smscTotalPages ? this.smscTotalPages : 10,
        order_by: order_by,
        order_dir: order_dir,
      });
      this.loading = false;
    },
    transformVendor(vendor) {
      return {
        name: vendor.vendor_name,
        value: vendor.vendor_name,
      };
    },
    transformUser(item) {
      return {
        value: item.user_name,
        name: item.user_name,
        id: item.user_id,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.equal-field {
  width: 230px !important;
}

.sms-log-container {
  // padding: 0 20px;

  .per-page-box {
    display: flex;
    align-items: center;
    margin-top: 20px;

    .header {
      margin-right: 10px;
    }
    .item {
      width: 120px;

      div,
      select {
        width: 120px;
      }
    }
  }
  .time-th {
    min-width: 180px;
  }
  [data-title]:hover:after {
    opacity: 1;
    transition: all 0.1s ease 0.5s;
    visibility: visible;
  }
  [data-title]:after {
    content: attr(data-title);
    background-color: white;
    color: #111;
    font-size: 15px;
    position: absolute;
    padding: 6px 10px;
    top: 3em;
    left: 0%;
    width: auto;
    box-shadow: 1px 1px 3px #343232;
    opacity: 0;
    height: auto;
    border: 1px solid grey;
    z-index: 99999;
    // visibility: hidden;
  }
  [data-title] {
    position: relative;
  }
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: auto;
    margin-top: 20px;
    margin-bottom: 50px;
    .right-wrapper {
      display: flex;
      width: 100%;
      flex-direction: row-reverse;
      align-items: center;
      // margin: 0 auto;

      .first-line {
        display: flex;
        justify-content: space-between;
        width: 100%;

        .search-boxes {
          display: block;
          margin-top: 15px;

          div {
            float: left;
            margin-right: 22px;
            // margin-top: 15px;
          }
          div:first-child {
            margin-left: 0;
          }
          div:last-child {
            margin-right: 0;
          }
        }
        .btns {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          align-content: flex-start;
        }
      }
      .search-input {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        height: 40px;
        margin-right: 10px;
        background-color: #fff;

        .icon {
          left: 5px;
          position: absolute;
          height: 30px;
          width: 30px;
        }
        input {
          z-index: 2;
          width: 100%;
          height: 100%;
          border: 1px solid #edeef3;
          border-radius: 4px;
          background-color: #fff;
          font-family: Helvetica Neue;
          font-size: 16px;
          line-height: 25px;
          padding-left: 40px;
          background-color: transparent;
        }
      }
      .reset-button {
        width: 90px;
        height: 40px;
        margin: 10px 0 0 10px;
      }
      .second-line {
        display: flex;
        width: 100%;
        .selects-wrapper {
          display: flex;
          justify-content: flex-start;
          width: 100% !important;
          // margin-bottom: 30px;

          .parent-item {
            display: flex;
            .item {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              margin: 0 10px;
              flex-grow: 1;
              div {
                display: inline-block;
              }
            }
          }
          .parent-item:first-child {
            .item:first-child {
              margin-left: 0;
            }
          }
          .parent-item:last-child {
            .item:last-child {
              margin-right: 0;
            }
          }
          .per_page {
            width: 110px;
          }

          .choose-type {
            height: 40px;
            color: #55616e;
            font-weight: 400;
          }
          .inputs {
            display: flex;

            div {
              margin-right: 10px;
            }
            &:last-child {
              // margin-top: 25px;

              div.el-date-editor {
                width: 485px;
              }
            }
            .equal-field.date-picker {
              margin-right: 20px;
            }
            &.date-inputs div:first-child {
              margin-bottom: 5px;
            }
          }
        }
        .btns {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 30px;
        }
        .header {
          margin-bottom: 5px;
          font-family: Helvetica Neue;
          font-size: 16px;
          font-weight: 400;
          // text-align: center;
          color: #55616e;
        }
      }
    }
  }
}
.word-break p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
}
.box.equal-field {
  width: 232px !important;
}
.PrimaryButton {
  cursor: pointer;
  height: 40px;
  width: 100%;
  border-radius: 4px;
  background-color: #51a3f3;
  color: #fff;
  outline: none;
  border: none;
  font-family: "Helvetica Neue";
  font-size: 16px;
  font-weight: 500;
  line-height: 30px;
  text-align: center;
  padding: 5px 20px 5px 20px;
}
.secondary-button {
  cursor: pointer;
  height: 100%;
  width: 100%;
  border: 1px solid #bdbfd8;
  border-radius: 4px;
  background-color: #fff;
  color: #55616e;
  font-family: "Helvetica Neue";
  font-size: 16px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  padding: 10px 20px 10px 20px;
}
table.Invoice_table {
  width: 100%;

  th {
    text-align: center;

    &.sms-text {
      width: 340px;
      padding-left: 0;
      padding-right: 0;
    }
  }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
  th {
    border-bottom-width: 2px;
    color: white;
    padding-left: 10px;
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
    border: 1px solid #dee2e6;
  }
}
table,
tr {
  width: 100%;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}

table {
  border-collapse: collapse;
}
.Invoice_table_popup {
  width: 75px;
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;

  .sorting {
    cursor: pointer;
  }
}
.Invoice_table_header th:first-child {
  padding-left: 20px;
  padding-right: 30px;
  width: 14%;
}
tbody th:first-child {
  padding-left: 20px;
  padding-right: 30px;
}
tbody th {
  height: 40px;
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 20px;
  padding: 15px 20px;
}
tr th.icon {
  width: 80x;
  float: right;
}
tbody {
  th.icon {
    padding: 7px 20px 7px 0;
    .edit {
      margin-right: 20px;
    }
  }
  .img-container {
    padding: 7px 0;
  }
  th.text {
    max-width: 450px;

    span {
      pointer-events: none;
    }
  }
}
.Invoice_price {
  font-family: "Helvetica Neue";
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px;
}
th.user_active:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24e2b8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 20px;
}

th.user_active {
  text-align: left;
  position: relative;
  padding-left: 35px;
}
th .svg-grey {
  cursor: pointer;
  fill: #55616e;
}
th .callflow {
  font-size: 12px;
  width: 86px;
  height: 20px;
  padding-top: 0px;
  float: right;
  line-height: 20px;
}
th .number-icon {
  height: 16px;
  width: 16px;
  margin-right: 8px;
}
.primary-input-container {
  .primary-select-wrapper {
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 40px;
    border: 1px solid #edeef3;
    border-radius: 4px;
    background-color: #fff;
    select {
      -webkit-appearance: none;
      -moz-appearance: none;
      -ms-appearance: none;
      appearance: none;
      width: 100%;
      // height: 100%;
      min-height: 38px;
      background: #fff;
      padding-left: 15px;
      font-family: Helvetica Neue;
      font-size: 16px;
      line-height: 25px;
    }
    .icon-down {
      left: 100%;
      margin-left: -35px;
      background: #fff;
    }
  }
  .pimary-input-title {
    color: #000;
    font-family: "Helvetica Neue";
    font-size: 12px;
    font-weight: 300;
    letter-spacing: 0.21px;
    line-height: 15px;
    margin-bottom: 5px;
    text-transform: uppercase;
  }
}
.no-data-found {
  padding: 20px;
  text-align: center;
  font-size: 20px;
  color: #e2e5ea;
  background-color: #fff;
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
@media screen and (max-width: 1775px) {
  .sms-log-container .add-navigation .right-wrapper {
    display: flex;
    width: 100%;
    flex-direction: column-reverse;

    .first-line {
      margin-top: 15px;

      .btns {
        flex-grow: 1;
      }
    }
    .second-line .selects-wrapper .inputs {
      flex-wrap: wrap;
    }
  }
}
@media (max-width: 1610px) {
  table.Invoice_table {
    width: 1500px;
  }
}
@media screen and (max-width: 850px) {
  .sms-log-container .add-navigation .right-wrapper {
    width: 100%;
    flex-direction: row-reverse;
    align-items: flex-start;
    justify-content: space-between;
    // padding: 0 15%;
  }
  .sms-log-container .add-navigation .right-wrapper .first-line {
    width: fit-content;
    flex-direction: column;
  }
  .sms-log-container .add-navigation .right-wrapper .second-line {
    flex-direction: column;
  }
  .sms-log-container .add-navigation .right-wrapper .first-line .search-boxes {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 26px;
    // padding-top: 24px;
  }
  .sms-log-container .add-navigation .right-wrapper .first-line .btns {
    width: 230px;
    justify-content: center;
  }
  .sms-log-container
    .add-navigation
    .right-wrapper
    .first-line
    .search-boxes
    div:first-child {
    margin-top: 0;
  }
  .sms-log-container
    .add-navigation
    .right-wrapper
    .first-line
    .search-boxes
    div {
    margin: 38px 0 0;
    float: none;
  }
  .sms-log-container
    .add-navigation
    .right-wrapper
    .first-line
    .search-boxes
    div:last-child {
    margin-right: 0;
  }
  .sms-log-container
    .add-navigation
    .right-wrapper
    .first-line
    .btns
    div:first-child {
    margin: 10px 0 0 0;
  }
  .sms-log-container .add-navigation .right-wrapper .first-line .btns {
    justify-content: space-between;
  }
  .sms-log-container
    .add-navigation
    .right-wrapper
    .second-line
    .selects-wrapper
    .inputs {
    flex-direction: column;
    align-items: center;
  }
  .sms-log-container
    .add-navigation
    .right-wrapper
    .second-line
    .selects-wrapper
    .inputs
    .item:first-child {
    margin-top: 0 !important;
  }
  .sms-log-container
    .add-navigation
    .right-wrapper
    .second-line
    .selects-wrapper
    .inputs
    .item {
    margin: 38px 0 0 !important;
  }
  .sms-log-container
    .add-navigation
    .right-wrapper
    .second-line
    .per-page-box
    .item
    div {
    margin: 0 auto;
  }
}
@media (max-width: 830px) {
  .sms-log-container .add-navigation .right-wrapper {
    display: flex;
    flex-direction: column-reverse;

    .first-line {
      width: 100%;
      margin-top: 0;

      .search-boxes {
        flex-direction: row;

        .equal-field:last-child {
          margin: 0 0 0 10px;
        }
      }
    }
  }
}
.row{
  align-items: center;
}
@media (max-width: 341px) {
  .margin_top_button{
    margin-top: 15px;
  }
}
</style>